
import { EMPLOYEE_HOME_HOTJAR_SITE_ID } from "@/constants/hotjar";
import { SMCases, SMHotjar, SMTasks, SMUser } from "@/store";
import { Component, Vue } from "vue-property-decorator";

SMHotjar.initHotjar(EMPLOYEE_HOME_HOTJAR_SITE_ID);

@Component({
  components: {
    // TasksTable: () => import("@/modules/Tasks/Table/TasksTable.vue"),
    TasksTableV3: () => import("@/modules/Tasks/Table/TasksTableV3.vue"),
    ToDoTasksTable: () => import("@/modules/Tasks/ToDoTasksTable/ToDoTasksTable.vue"),
    WidgetSkilledWorkerDependantVisa: () =>
      import("@/modules/Compliance/Widgets/WidgetSkilledWorkerDependantVisa.vue"),
    ComplianceWidgetEmployee: () =>
      import("@/modules/Compliance/ComplianceWidgets/ComplianceWidgetEmployee.vue"),
  },
})
export default class Home extends Vue {
  get isComplianceBlocked() {
    return SMUser.user?.is_compliance_blocked;
  }

  get items() {
    return SMTasks.myTasks;
  }

  get widgets() {
    return {
      dependantVisa: !!this.serviceWithEnableStartDependantsVisa,
    };
  }

  get hasSomeEnableWidget() {
    const { widgets } = this;

    return Object.keys(widgets).some((key) => widgets[key] === true);
  }

  get tasksCount() {
    return this.items.length;
  }

  openTask() {
    const item = this.items[0];
    const path = `${SMUser.basePath}/tasks/${item.id}`;

    this.$router.push(path);
  }

  dialogs = {
    welcome: false,
    widgetSubmit: false,
  };

  openSuccessPopup() {
    this.dialogs.widgetSubmit = true;
  }

  closeSuccessPopup() {
    this.dialogs.widgetSubmit = false;
  }

  get serviceWithEnableStartDependantsVisa() {
    return SMCases.serviceWithEnableStartDependantsVisa;
  }
}
